'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
require('./Alert-13b75102.js');
require('./Badge-757b0a39.js');
require('./Popover-569cd272.js');
require('./Tab-f499ecbc.js');
require('./Tabs-a8c77f71.js');
var Tooltip = require('./Tooltip-66daf6e3.js');
require('./VerificationStatusIcon-d5bfb67a.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/React__namespace.createElement("path", {
  fill: "currentColor",
  d: "M7.65 38l3.25-14.05L0 14.5l14.4-1.25L20 0l5.6 13.25L40 14.5l-10.9 9.45L32.35 38 20 30.55 7.65 38z"
});

function SvgStarFilled(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 38"
  }, props), _ref$1);
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React__namespace.createElement("path", {
  fill: "currentColor",
  d: "M12.2 31.8l7.8-4.7 7.9 4.8-2.1-8.9 6.9-6-9.1-.8L20 7.7l-3.5 8.4-9.1.8 6.9 6-2.1 8.9zM7.7 38L11 24 0 14.5l14.4-1.2L20 0l5.6 13.2L40 14.5 29.1 24l3.3 14L20 30.6 7.7 38z"
});

function SvgStar(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 38"
  }, props), _ref);
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21;
var fadeIn = styled.keyframes(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  from {\n    background-color: ", ";\n  }\n  to {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.themeProp('rgba(48, 130, 106, 0)', 'rgba(191, 224, 213, 0)');
}, function (props) {
  return props.theme.themeProp('rgba(48, 130, 106, 1)', 'rgba(191, 224, 213, 1)');
});
var fadeOut = styled.keyframes(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n  from {\n    background-color: ", ";\n  }\n  to {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.themeProp('rgba(48, 130, 106, 1)', 'rgba(191, 224, 213, 1)');
}, function (props) {
  return props.theme.themeProp('rgba(48, 130, 106, 0)', 'rgba(191, 224, 213, 0)');
});
var fadeInCheck = styled.keyframes(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n  from {\n    opacity: 0\n  }\n  to {\n    opacity: 1\n  }\n"])));
var fadeOutCheck = styled.keyframes(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n  from {\n    opacity: 1\n  }\n  to {\n    opacity: 0\n  }\n"])));
var CompactStarRating$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 1rem;\n  font-weight: 500;\n  height: 24px;\n  width: 100%;\n  display: flex;\n\n  align-items: center;\n  input[type='number'] {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n    margin: 0;\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.primaryFontFamily;
}, function (props) {
  return props.readOnly && styled.css(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n      pointer-events: none;\n    "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject7 || (_templateObject7 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 0.5;\n      cursor: not-allowed;\n    "])));
});
var labelWidth = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject8 || (_templateObject8 = defaultTheme._taggedTemplateLiteral(["\n  width: 33.33%;\n  display: flex;\n  align-items: center;\n  text-align: left;\n  font: normal normal normal 14px/16px Roboto;\n  letter-spacing: 0px;\n  padding: 0;\n  height: 19px;\n  cursor: default;\n  justify-content: space-between;\n  ", ";\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('gray-700'));
}, function (props) {
  return props.disabled && styled.css(_templateObject9 || (_templateObject9 = defaultTheme._taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
});
var SuccessContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject10 || (_templateObject10 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 1;\n  pointer-events: none;\n  display: flex;\n  opacity: ", ";\n  animation: ", " 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n  margin-right: 5px;\n  ", "\n  > svg {\n    width: 13px;\n  }\n"])), function (props) {
  return props.fadeIn ? 0 : 1;
}, function (props) {
  return props.fadeIn ? fadeOutCheck : fadeInCheck;
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-500'));
});
var starsWidth = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject11 || (_templateObject11 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  width: 66.66%;\n  border-radius: 3px;\n  height: 24px;\n  align-items: center;\n  padding-left: 8px;\n  box-sizing: border-box;\n  border: 1px solid;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  &&:not(:hover):not(:focus) {\n    ", ";\n    ", ";\n  }\n  &&:hover:not(:focus) {\n    ", "\n\n    ", ";\n\n    ", ";\n\n    ", ";\n  }\n"])), function (props) {
  return props.theme.themeProp('border-color', props.theme.getColor('gray-900'), props.theme.getColor('white'));
}, function (props) {
  return props.type === 'success' && styled.css(_templateObject12 || (_templateObject12 = defaultTheme._taggedTemplateLiteral(["\n      animation: ", " 0.5s ease-in-out;\n    "])), function (props) {
    return props.success ? fadeIn : fadeOut;
  });
}, function (props) {
  return props.type === 'error' && styled.css(_templateObject13 || (_templateObject13 = defaultTheme._taggedTemplateLiteral(["\n      ", ";\n      ", "\n    "])), props.theme.themeProp('background', '#7F1B1B', '#FBEAE6'), props.theme.themeProp('border-color', '#7f1b1b', '#FBEAE6'));
}, function (props) {
  return props.type === 'warning' && styled.css(_templateObject14 || (_templateObject14 = defaultTheme._taggedTemplateLiteral(["\n      ", ";\n      ", "\n    "])), props.theme.themeProp('background', '#634E01', '#FFFDE8'), props.theme.themeProp('border-color', '#2F2402 ', '#FFFDE8'));
}, function (props) {
  return props.edit && props.theme.themeProp('background', 'rgba(39,39,42, 0.7)', 'rgba(244,244,245, 0.3)');
}, function (props) {
  return props.edit && props.theme.themeProp('border-color', 'rgba(39,39,42, 0.7)', 'rgba(228,228,231, 0.3)');
}, function (props) {
  return props.edit && props.theme.themeProp('background', props.theme.getColor('gray-700'), props.theme.getColor('gray-100'));
}, function (props) {
  return props.edit && props.theme.themeProp('border-color', props.theme.getColor('gray-700'), props.theme.getColor('gray-100'));
}, function (props) {
  return props.type === 'warning' && !props.readOnly && props.theme.themeProp('background', '#806403', '#FFFEBF');
}, function (props) {
  return props.type === 'error' && !props.readOnly && props.theme.themeProp('background', '#901d1d', '#f7d5d0');
});
var Star = styled__default['default'].button.attrs(defaultTheme.applyDefaultTheme)(_templateObject15 || (_templateObject15 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n\n  svg {\n    height: 12px;\n    padding-left: 4px;\n    transition: color 250ms;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('black'));
}, function (props) {
  return props.type === 'warning' && props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('black'));
}, function (props) {
  return props.type === 'warning' && props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('black'));
}, function (props) {
  return props.hover && props.theme.themeProp('color', props.theme.getColor('orange-500'), props.theme.getColor('orange-500'));
}, function (props) {
  return props.readOnly && styled.css(_templateObject16 || (_templateObject16 = defaultTheme._taggedTemplateLiteral(["\n      pointer-events: none;\n    "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject17 || (_templateObject17 = defaultTheme._taggedTemplateLiteral(["\n      button {\n        cursor: not-allowed;\n      }\n      > * {\n        cursor: not-allowed;\n      }\n    "])));
});
var StarFill = styled__default['default'].button.attrs(defaultTheme.applyDefaultTheme)(_templateObject18 || (_templateObject18 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n\n  svg {\n    height: 12px;\n    padding-left: 4px;\n    transition: color 250ms;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('black'));
}, function (props) {
  return props.type === 'error' && props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('black'));
}, function (props) {
  return props.type === 'warning' && props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('black'));
}, function (props) {
  return props.hover && props.theme.themeProp('color', props.theme.getColor('orange-500'), props.theme.getColor('orange-500'));
}, function (props) {
  return props.readOnly && styled.css(_templateObject19 || (_templateObject19 = defaultTheme._taggedTemplateLiteral(["\n      pointer-events: none;\n    "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject20 || (_templateObject20 = defaultTheme._taggedTemplateLiteral(["\n      button {\n        cursor: not-allowed;\n      }\n      > * {\n        cursor: not-allowed;\n      }\n    "])));
});
styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject21 || (_templateObject21 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 1;\n  pointer-events: none;\n  margin-left: auto;\n  opacity: ", ";\n  animation: ", " 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n  ", "\n  > svg {\n    width: 13px;\n  }\n"])), function (props) {
  return props.type === 'success' ? 0 : 1;
}, function (props) {
  return props.type === 'success' ? fadeOutCheck : fadeInCheck;
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('emerald-200'), props.theme.getColor('emerald-500'));
});

var CompactStarRating = React__default['default'].forwardRef(function CompactStarRating(_ref, forwardedRef) {
  var label = _ref.label,
      icon = _ref.icon,
      iconFill = _ref.iconFill,
      max = _ref.max,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      name = _ref.name,
      viewEmpty = _ref.viewEmpty,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      type = _ref.type,
      descriptionToolTip = _ref.descriptionToolTip,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      edit = _ref.edit,
      hidden = _ref.hidden,
      loadingIcon = _ref.loadingIcon,
      successIcon = _ref.successIcon,
      props = defaultTheme._objectWithoutProperties(_ref, ["label", "icon", "iconFill", "max", "defaultValue", "value", "name", "viewEmpty", "onChange", "onBlur", "type", "descriptionToolTip", "disabled", "readOnly", "edit", "hidden", "loadingIcon", "successIcon"]);

  var stars = Array.from(Array(max).keys());

  var _useState = React.useState(''),
      _useState2 = defaultTheme._slicedToArray(_useState, 2),
      rating = _useState2[0],
      setRating = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = defaultTheme._slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var _useState5 = React.useState(''),
      _useState6 = defaultTheme._slicedToArray(_useState5, 2),
      tempRating = _useState6[0],
      setTempRating = _useState6[1];

  var _useState7 = React.useState(''),
      _useState8 = defaultTheme._slicedToArray(_useState7, 2),
      initialRating = _useState8[0],
      setInitialRating = _useState8[1];

  var inputRef = React.useRef();
  React.useEffect(function () {
    setRating(value || defaultValue);
    setInitialRating(value || defaultValue);
  }, [value, defaultValue]);
  React.useEffect(function () {
    inputRef.current.value = String(rating);

    if (rating === initialRating) {
      return undefined;
    } else {
      setInitialRating(rating);
      onChange({
        target: inputRef.current
      });
    }
  }, [rating]);
  var memoizedDescriptionToolTip = React.useMemo(function () {
    return descriptionToolTip;
  }, [descriptionToolTip]);

  var starIconRender = function starIconRender(key) {
    if (rating > 0 && rating >= key + 1) {
      return React__default['default'].createElement(StarFill, {
        readOnly: readOnly,
        disabled: disabled,
        onClick: function onClick(event) {
          event.preventDefault();

          if (key + 1 > 1) {
            return setRating(key + 1);
          } else if (key + 1 == 1) {
            setRating(function (current) {
              return current === 1 ? 0 : key + 1;
            });
          }
        },
        onMouseEnter: function onMouseEnter() {
          setTempRating(key + 1);
          setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          setTempRating(0);
          setHover(false);
        },
        hover: hover && key + 1 <= tempRating,
        type: type,
        key: key
      }, iconFill);
    } else if (viewEmpty) {
      return React__default['default'].createElement(Star, {
        readOnly: readOnly,
        disabled: disabled,
        onClick: function onClick(event) {
          event.preventDefault();
          setRating(key + 1);
        },
        onMouseEnter: function onMouseEnter() {
          setTempRating(key + 1);
          setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          setTempRating(0);
          setHover(false);
        },
        hover: hover && key + 1 <= tempRating,
        type: type,
        key: key
      }, icon);
    }
  };

  var input = function input() {
    return React__default['default'].createElement(CompactStarRating$1, defaultTheme._extends({
      ref: forwardedRef,
      readOnly: readOnly,
      disabled: disabled,
      onChange: onChange,
      onBlur: onBlur
    }, props), React__default['default'].createElement(labelWidth, {
      disabled: disabled
    }, label, React__default['default'].createElement(SuccessContainer, null, type === 'loading' && loadingIcon, type === 'success' && successIcon)), React__default['default'].createElement(starsWidth, {
      edit: edit,
      type: type
    }, stars.map(function (key) {
      return React__default['default'].createElement("div", {
        key: key
      }, React__default['default'].createElement("input", {
        type: "number",
        name: name,
        ref: inputRef
      }), starIconRender(key));
    })));
  };

  if (hidden) return null;
  return React__default['default'].createElement(React__default['default'].Fragment, null, !memoizedDescriptionToolTip && input(), memoizedDescriptionToolTip && React__default['default'].createElement("div", null, React__default['default'].createElement(Tooltip.Tooltip, {
    content: memoizedDescriptionToolTip,
    key: "tooltipTextArea1",
    placement: "bottom-end",
    trigger: 'mouseenter',
    zIndex: 999999
  }, input())));
});
CompactStarRating.propTypes = process.env.NODE_ENV !== "production" ? {
  readOnly: defaultTheme.PropTypes.bool,
  disabled: defaultTheme.PropTypes.bool,
  edit: defaultTheme.PropTypes.bool,
  value: defaultTheme.PropTypes.number,
  type: defaultTheme.PropTypes.oneOf(['', 'error', 'warning', 'loading', 'success']),
  defaultValue: defaultTheme.PropTypes.number,
  label: defaultTheme.PropTypes.string,
  name: defaultTheme.PropTypes.string,
  icon: defaultTheme.PropTypes.element,
  iconFill: defaultTheme.PropTypes.element,
  max: defaultTheme.PropTypes.number,
  viewEmpty: defaultTheme.PropTypes.bool,
  onChange: defaultTheme.PropTypes.func,
  onBlur: defaultTheme.PropTypes.func,
  hidden: defaultTheme.PropTypes.bool,
  loadingIcon: defaultTheme.PropTypes.element,
  successIcon: defaultTheme.PropTypes.element,
  descriptionToolTip: defaultTheme.PropTypes.string
} : {};
CompactStarRating.defaultProps = {
  label: 'Rating',
  max: 5,
  value: 0,
  defaultValue: 0,
  viewEmpty: true,
  icon: React__default['default'].createElement(SvgStar, null),
  iconFill: React__default['default'].createElement(SvgStarFilled, null),
  hidden: false,
  type: '',
  descriptionToolTip: '',
  displayDescriptionToolTip: false,
  onChange: function onChange() {}
};

exports.CompactStarRating = CompactStarRating;
